import { Checkbox, InputLabel, Stack, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useContext, useMemo } from 'react';
import WarningPopup from '../Popups/WarningPopup';
import { useTripRateContext } from '../TripRate/TripRateContext';
import { SessionContext } from '../Contexts/SessionContext';
import { getFilteredSurveys } from '../TripRateNew/TriprateFilters';
import { CounterBadge } from '../Utilities/CounterBadge';

export default function Population500m() {
    const { surveys } = useTripRateContext();
    const { sessionState, setSessionField } = useContext(SessionContext);

    const minMaxParam = useMemo(() => {
        if (!Array.isArray(surveys) || surveys.length === 0) return null;

        const list = getFilteredSurveys(
            surveys
        );

        const validValues = list
            .map(s => s.pop500)
            .filter(v => typeof v === 'number' && !isNaN(v)) as number[];

        if (validValues.length === 0) return null;

        const min = Math.min(...validValues);
        const max = Math.max(...validValues);
        const avg = validValues.reduce((a, b) => a + b, 0) / validValues.length;

        setSessionField('secondaryFilters.population500MeterMin', min);
        setSessionField('secondaryFilters.population500MeterMax', max);

        return { min, max, avg };
    }, [surveys]);

    const pop500Checked = sessionState?.secondaryFilters?.Population500MeterChecked ?? true;

    const min = sessionState?.secondaryFilters?.population500MeterMin ?? '';
    const max = sessionState?.secondaryFilters?.population500MeterMax ?? '';

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSessionField('secondaryFilters.Population500MeterChecked', e.target.checked);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const parsed = value === '' ? '' : Number(value);

        if (name === 'minPopulation500m') {
            setSessionField('secondaryFilters.population500MeterMin', parsed);
        } else if (name === 'maxPopulation500m') {
            setSessionField('secondaryFilters.population500MeterMax', parsed);
        }
    };

    return (
        <Grid container component={Paper} size={12} alignItems="center" sx={{ position: 'relative' }}>
            <CounterBadge value={4} />

            <Grid size={12}>
                    <Typography textAlign="center">Population within 500m Range<WarningPopup
                        title="Warning on Population within 500m"
                        content="By default, all surveys are selected. However, be aware that some sites have unknown numbers of Population within 500m, and if users activate the Population within 500m selection by unticking the box, then all sites with unknown levels of Population within 500m will be excluded from the selected list."
                        type="warning"
                    /></Typography>
                    
            </Grid>

            <Grid size={6}>
                <Stack spacing={1} direction="row" alignItems="center">
                    <InputLabel id="population500mLabel">All Sites Selected</InputLabel>
                    <Checkbox
                        name="population500mChecked"
                        checked={pop500Checked}
                        onChange={handleCheckboxChange}
                    />
                </Stack>
            </Grid>

            <Grid container size={12}>
                <Grid size={4}>
                    <Stack spacing={3}>
                        <Typography variant="body1">
                            Minimum: {minMaxParam?.min ?? '�'}
                        </Typography>
                        <Typography variant="body1">
                            Maximum: {minMaxParam?.max ?? '�'}
                        </Typography>
                    </Stack>
                </Grid>

                {!pop500Checked && (
                    <Grid size={8}>
                        <Stack spacing={1}>
                            <Grid size={12}>
                                <TextField
                                    name="minPopulation500m"
                                    value={min}
                                    onChange={handleInputChange}
                                    label="From:"
                                    type="number"
                                />
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    name="maxPopulation500m"
                                    value={max}
                                    onChange={handleInputChange}
                                    label="To:"
                                    type="number"
                                />
                            </Grid>
                        </Stack>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
}
